<template>
  <v-app>
    <v-toolbar color="primary"
               dark
               fixed
               app>
      <v-spacer></v-spacer>
      <router-link to="/"
                   class="align-self-end">
        <img src="/image/logo_bg_white.png"
             width="200px"
             height="40px" />
      </router-link>
      <v-spacer></v-spacer>

    </v-toolbar>

    <v-content app>
      <v-container fluid
                   class="minHeight">
        <v-layout justify-center>
          <v-flex xs12
                  md8>
            <!-- <h1 class="mt-5 mb-3 primary--text">{{ $t(store.state.activeSection) }}</h1> -->
            <router-view></router-view>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <wsp-footer expandedFooter></wsp-footer>
  </v-app>
</template>

<script>
import WspFooter from '@/components/commons/WspFooter';

export default {
  name: 'RegisterLayout',
  components: {
    [WspFooter.name]: WspFooter
  },
  data: () => ({})
};
</script>

<style lang="scss">
@import '~@/assets/css/public.scss';
</style>
